import { Grid, Typography } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import {
  AutocompleteMultiSelect,
  ComponentHeader,
  TextField,
} from "../../../../components";
import { useAxios } from "../../../../hooks";

export default function FormSeventh({
  component = "",
  formikProps,
  editState,
  preferredChannels,
  forceClick,
  isDisabled,
}) {
  const axios = useAxios();
  const [fields, setFields] = useState([]);
  const { agent, role } = useSelector((state) => state.memberDetails);

  function handleAddField() {
    if (formikProps.values.pref_campaign_channel.value.length > 0) {
      axios({
        url: "/channel-dynamic-fields",
        method: "POST",
        disableRedirect: true,
        data: {
          channel_ids: formikProps.values.pref_campaign_channel.value,
        },
      }).then((res) => {
        if (res.status) {
          setFields(res.data);
          let names = Object.keys(res.data).map((key) =>
            res.data[key].map((item) => item.field_name)
          );
          formikProps.setValues((prevVal) => ({
            ...prevVal,
            channelFields: names,
          }));
        }
      });
    }
  }

  useEffect(() => {
    if (formikProps.values.campaignID) {
      axios({
        url: "/channel-dynamic-fields",
        method: "POST",
        disableRedirect: true,
        data: {
          channel_ids: formikProps.values.pref_campaign_channel.value,
        },
      }).then((res) => {
        if (res.status) {
          setFields(res.data);
          let names = Object.keys(res.data)
            .map((key) => res.data[key].map((item) => item.field_name))
            .flat();
          formikProps.setValues((prevVal) => ({
            ...prevVal,
            channelFields: names,
          }));
        }
      });
    }
  }, [axios, formikProps.values.campaignID]);

  return (
    <Fragment>
      <Grid size={12}>
        <ComponentHeader
          title={"Preferred Channel"}
          subtitle={
            component === ""
              ? "Select channel where you want to run the campaign"
              : "Selected Channel"
          }
        />
      </Grid>

      <Grid size={4}>
        <AutocompleteMultiSelect
          required={true}
          forcePopupIcon={!editState ? false : true}
          label={"Select Preferred Channel"}
          name="pref_campaign_channel.value"
          formikProps={formikProps}
          disabled={
            component === "" &&
            !isDisabled &&
            formikProps.values.newCampaignStatus !== "CREATED"
              ? forceClick
              : !editState
          }
          placeholder="Select Preferred Channel"
          defaults={{
            primaryKey: "id",
            displayLabel: "channel_name",
          }}
          sx={{
            "& .MuiSvgIcon-root": {
              display: !editState && "none",
            },
          }}
          options={
            agent?.length || role === "SUPER_ADMIN"
              ? preferredChannels
              : preferredChannels.filter((item) => item.id !== 1)
          }
          getOptionDisabled={(option) => !option.is_active}
          onBlur={() => {
            handleAddField();
          }}
          onChange={(_, arr, reason, option) =>
            handleChangeChannel(
              arr,
              option,
              "pref_campaign_channel.value",
              "id"
            )
          }
        />
      </Grid>

      {Object.keys(fields).length > 0 &&
        Object.keys(fields).map((field, index) => (
          <Fragment key={index}>
            {parseInt(field) === 3 && (
              <Grid size={12}>
                <Typography variant="h6">Meta Delivery Details</Typography>
              </Grid>
            )}
            {parseInt(field) === 5 && (
              <Grid size={12}>
                <Typography variant="h6">Google Delivery Details</Typography>
              </Grid>
            )}
            {parseInt(field) === 6 && (
              <Grid size={12}>
                <Typography variant="h6">DV360 Delivery Details</Typography>
              </Grid>
            )}
            {fields[field].map((item, idx) => (
              <Grid size={4} key={idx}>
                <TextField
                  required
                  size="small"
                  name={`${item.field_name}.value`}
                  label={item.field_label}
                  formikProps={formikProps}
                  disabled={
                    component === "" &&
                    !isDisabled &&
                    formikProps.values.newCampaignStatus !== "CREATED"
                      ? forceClick
                      : !editState
                  }
                />
              </Grid>
            ))}
          </Fragment>
        ))}

      {/* {formikProps.values.platformID === 1 && (
        <Fragment>
          {formikProps.values.pref_campaign_channel?.value?.includes(3) && (
            <Grid size={12}>
              <Typography variant="h6">Meta Delivery Details</Typography>
            </Grid>
          )}

          {formikProps.values.pref_campaign_channel?.value?.includes(3) &&
            formikProps.values?.meta_delivery_type?.value === "MANUAL" && (
              <Grid size={4}>
                <TextField
                  required
                  size="small"
                  name="ad_manager_id.value"
                  label="Ad Manager ID"
                  formikProps={formikProps}
                  disabled={!editState}
                />
              </Grid>
            )}

          {formikProps.values.pref_campaign_channel?.value?.includes(6) && (
            <Grid size={12}>
              <Typography variant="h6">DV360 Delivery Details</Typography>
            </Grid>
          )}

          {formikProps.values.pref_campaign_channel?.value?.includes(6) &&
            formikProps.values?.dv_delivery_type?.value === "MANUAL" && (
              <Fragment>
                <Grid size={4}>
                  <TextField
                    required
                    size="small"
                    name="dv_partner_id.value"
                    label="DV Partner ID"
                    formikProps={formikProps}
                    disabled={!editState}
                  />
                </Grid>

                <Grid size={4}>
                  <TextField
                    required
                    size="small"
                    name="dv_advertiser_id.value"
                    label="DV Advertiser ID"
                    formikProps={formikProps}
                    disabled={!editState}
                  />
                </Grid>

                <Grid size={4}>
                  <TextField
                    required
                    size="small"
                    name="dv_advertiser_name.value"
                    label="DV Advertiser Name"
                    formikProps={formikProps}
                    disabled={!editState}
                  />
                </Grid>
              </Fragment>
            )}
        </Fragment>
      )} */}
    </Fragment>
  );

  function handleChangeChannel(arr, { option }, name, displayName) {
    let objectName = name.substring(0, name.indexOf("."));

    formikProps.setValues((prevVal) => ({
      ...prevVal,
      [objectName]: setValuesOfDropDown(prevVal[objectName]),
    }));

    function setValuesOfDropDown(val) {
      let values = [...val.value];

      const index = values.indexOf(option[displayName]);
      if (index > -1) {
        values.splice(index, 1);
        let field = { ...fields };
        delete field[option[displayName]];
        setFields(field);
      } else {
        values.push(option[displayName]);
        axios({
          url: "/channel-dynamic-fields",
          method: "POST",
          disableRedirect: true,
          data: {
            channel_ids: [
              ...formikProps.values.pref_campaign_channel.value,
              option[displayName],
            ],
          },
        }).then((res) => {
          if (res.status) {
            setFields(res.data);
          }
        });
      }

      return {
        ...val,
        value: values,
      };
    }
  }
}
